import { countries } from "country-flag-icons";

export const getCountryFlagSrc = (countryCode: string) => {
  if (countries.includes(countryCode.toUpperCase())) {
    return `http://purecatamphetamine.github.io/country-flag-icons/3x2/${countryCode.toUpperCase()}.svg`;
  }

  return undefined;
};
